import { colors } from '../../lib/colors';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import { LEGACY_DAILY_CELL_HEIGHT_DEFAULT } from './legacyCalendarLayout';
dayjs.locale('ko');

const GridShadow = ({ currentDate, selectedDay, cellHeight = LEGACY_DAILY_CELL_HEIGHT_DEFAULT }: any) => {
    const minuteRatio = cellHeight / 60;
    return dayjs(selectedDay).format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD') ? (
        <div>
            <hr
                style={{
                    width: '92.5%',
                    top: 248 + parseInt(dayjs().format('H')) * cellHeight + parseInt(dayjs().format('m')) * minuteRatio + 5,
                    left: '7.5%',
                    border: '1.5px solid #2B529D',
                    position: 'absolute',
                }}
            />

            <div
                style={{
                    width: 8,
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: colors.BLUE_700,
                    position: 'absolute',
                    top: 248 + parseInt(dayjs().format('H')) * cellHeight + parseInt(dayjs().format('m')) * minuteRatio - 3 + 5,
                    left: '7.2%',
                }}
            />
        </div>
    ) : null;
};

export default GridShadow;
